import { FC } from 'react'
import { TooltipProps } from 'recharts'
import theme from 'theme'
import { formatWeekRange } from '../../categoryDashboard.utils'

const tooltipStyle: React.CSSProperties = {
  background: theme.colors.surfaceContainerBackground,
  border: 'none',
  borderRadius: '12px',
  padding: '16px',
  boxShadow: theme.colors.tooltipShadow,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  minWidth: '180px'
}

const dateStyle: React.CSSProperties = {
  fontFamily: theme.typography.fontFamily.primary,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20px',
  color: theme.colors.menuItemText
}

const rowsStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
}

const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const labelContainerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

const labelTextStyle: React.CSSProperties = {
  fontFamily: theme.typography.fontFamily.primary,
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '16px',
  color: theme.colors.devicesSecondaryText
}

const valueStyle: React.CSSProperties = {
  fontFamily: theme.typography.fontFamily.primary,
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '16px',
  color: theme.colors.menuItemText
}

const LEGEND_ITEMS = [
  { key: 'less', label: 'Less strict SLA', color: theme.colors.chartSeries1 },
  { key: 'same', label: 'Same SLA', color: theme.colors.chartSeries2 },
  { key: 'more', label: 'More Strict SLA', color: theme.colors.benchMoreStrict }
]

const BenchmarkingChartTooltip: FC<TooltipProps<any, any>> = ({ active, payload }) => {
  if (!active || !payload?.length) return null

  const fullDate = payload[0]?.payload?.fullDate
  const formattedDate = fullDate ? formatWeekRange(fullDate) : ''

  const dataMap: Record<string, number> = {}
  payload.forEach((entry: any) => {
    dataMap[entry.dataKey] = entry.value
  })

  return (
    <div style={tooltipStyle}>
      <div style={dateStyle}>{formattedDate}</div>
      <div style={rowsStyle}>
        {LEGEND_ITEMS.map((item) => (
          <div key={item.key} style={rowStyle}>
            <div style={labelContainerStyle}>
              <div style={{ width: 12, height: 12, borderRadius: 2, background: item.color, flexShrink: 0 }} />
              <span style={labelTextStyle}>{item.label}</span>
            </div>
            <span style={valueStyle}>{dataMap[item.key] != null ? `${dataMap[item.key]}%` : '-'}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BenchmarkingChartTooltip
